// extracted by mini-css-extract-plugin
module.exports = {"main":"Content_main__D3kme","nav":"Content_nav__3Lnf5","content":"Content_content__wHCnx","gadContainer":"Content_gadContainer__r4xxz"};